import { render, staticRenderFns } from "./Pdv.vue?vue&type=template&id=cc17ae7c&scoped=true&"
import script from "./Pdv.vue?vue&type=script&lang=js&"
export * from "./Pdv.vue?vue&type=script&lang=js&"
import style0 from "./Pdv.vue?vue&type=style&index=0&id=cc17ae7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc17ae7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
